import { render, staticRenderFns } from "./FiltrosFaturamentoServicos.vue?vue&type=template&id=af95e482"
import script from "./FiltrosFaturamentoServicos.vue?vue&type=script&lang=js"
export * from "./FiltrosFaturamentoServicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports